import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SelectedItemsCount.custom.scss';
import './SelectedItemsCount.theme.scss';

export default function SelectedItemsCount(props) {
  const { className, count, showZero = false } = props;
  if (count === 0 && !showZero) {
    return null;
  }
  return <span className={classnames(className, 'selected-items-count')}>{count}</span>;
}

SelectedItemsCount.propTypes = {
  className: PropTypes.string,
  showZero: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
